(function () {
    function g3Init(){
      
        let links = document.links;
        for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
          if (links[i].hostname !== window.location.hostname) {
            links[i].target = '_blank';
            links[i].rel = 'noreferrer noopener';
          }
        }

    //Control the line breaks in the product names
    document.querySelectorAll('h3.product-item__title > a').forEach(function (ele, index) {
    	ele.innerHTML = ele.innerHTML.replace(' – ', '<br><span class="prodSubTitle">').concat('</span>');
	});
    document.querySelectorAll('h1.product__heading').forEach(function (ele, index) {
    	ele.innerHTML = ele.innerHTML.replace(' – ', '<br><span class="prodSubTitle">').concat('</span>');
	});

    // Change top announcement bar for wholesale 
    let is_wholesale = false;
      let $announcement_bar = document.querySelector('.pxs-announcement-bar');
      let $desktop_announcement_bar = document.querySelector('.pxs-announcement-bar-text-desktop');
      let $mobile_announcement_bar = document.querySelector('.pxs-announcement-bar-text-mobile');
      let $announcement_deets = $announcement_bar.querySelector('small');
      
    if (typeof window.isWsgCustomer != "undefined" && isWsgCustomer) {
      $desktop_announcement_bar.innerHTML = '<strong>Welcome to the Mumbai to MAINE Wholesale Portal</strong>';
      $mobile_announcement_bar.innerHTML = '<strong>Welcome to the Mumbai to MAINE<br>Wholesale Portal</strong>';
      $announcement_deets.innerHTML = '<p><strong>Mumbai to MAINE</strong> is excited to leverage the buying power of Shopify\'s ecommerce platform to offer <strong>discounted shipping rates</strong> to our wholesale customers!</p><p>For a chance to save even more, be sure to check out our products on <strong><a href="LINK" target="_blank">FAIRE</a>!</strong>';
      document.querySelector('#shopify-section-pxs-announcement-bar').classList.add('wholesale-sticky');
      document.querySelector('#shopify-section-static-header').classList.add('wholesale-sticky');
    }
    console.log('Wholesale? ' + is_wholesale);
    
    //=========================================================================================
        //g3Loaded($mainContainer, function(){
            //initSomething();
        //});
        
        /*
        var $hid = document.getElementsByClassName('g3HiddenOnLoad');
        for(n=0; n<$hid.length; n++){
            let ele = $hid[n];
            g3Loaded(ele, function(){
                TweenMax.to(ele, .3, {alpha:1});
            });
        }
        */
        
    //=========================================================================================
    /* Check that all images are ready to go */
        var $divs = document.querySelectorAll('.g3MainContainer div');
        for(n=0; n<$divs.length; n++){
            var ele = $divs[n];
            style = ele.currentStyle || window.getComputedStyle(ele, false);
            var bg = window.getComputedStyle(ele, null).getPropertyValue("background-image");
            if(bg != 'none'){
                bg = bg.replace('url(','').replace(')','').replace(/\"/gi, "");
                ele.innerHTML += '<img src="' + bg + '" style="display:none;" />';
            }
        }
        function g3Loaded(ele, func) {
         let imgLoaded = 0;
         let $imgs = new Array();
         const $ele = document.querySelectorAll(ele);
         $ele.forEach(function (el, index) {
            if (el.querySelectorAll('img').length > 0) {
               el.querySelectorAll('img').forEach(function (img, index) {
                  $imgs.push(img);
               });
            } else if (el.tagName == 'IMG') {
               $imgs.push(el);
            } else {
               return;
            }
         });
         let imgQty = $imgs.length;

         function loadLoop() {
            for (i = 0; i < imgQty; i++) {
               let $img = document.createElement('img');
               $img.src = $imgs[i].src;
               $img.addEventListener('load', imageLoaded);
               $img.addEventListener('error', imageLoaded);
            }
         }
         if (imgQty > 0) {
            loadLoop();
         } else {
            allImagesLoaded();
         }

         function imageLoaded() {
            imgLoaded++;
            if (imgLoaded == imgQty) {
               allImagesLoaded();
            }
         }

         function allImagesLoaded() {
            func();
         }
      }
    };
    
    
    
    // Check for DOM and load external JS ====================================================
    var g3DomLoaded = false;
    
    if(document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) {
        g3Init();
    }else{
        document.addEventListener("DOMContentLoaded", g3Init);
    }
    
    
    function loadJS() {
		if (g3DomLoaded === false) {
			g3DomLoaded = true;
			loadScript(
				//'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.5.1/gsap.min.js',
				//'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.5.1/Draggable.min.js',
				//'https://content.g3logic.net/js/InertiaPlugin.min.js',
				//'https://cdnjs.cloudflare.com/ajax/libs/flexibility/2.0.1/flexibility.js',
				//'https://use.typekit.net/hyl3wze.js'
			);
		}
	}

    // Load Google webfonts: https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js
    // Load Adobe Typekit: https://use.typekit.net/TYPEKIT_NUMBER_HERE.js
    // Load VIMEO API: https://player.vimeo.com/api/player.js
    
    function loadScript(){
        var scriptsRequested = arguments.length;
        var scriptsLoaded = 0;
        for (var i = 0; i < scriptsRequested; i++) {
            var url = arguments[i];
            var script = document.createElement('script');
            (function(){
                script.type='text/javascript';
                script.src = url;
                document.head.appendChild(script);
                if (script.readyState){  //IE
                    script.onreadystatechange = function(){
                        if(script.readyState == "loaded" || script.readyState == "complete"){
                            callback();
                        }
                    };
                }else{
                    script.onload = function(){
                        callback();
                    };
                }
            })();
        }
        function callback(){
            scriptsLoaded++;
            if(scriptsLoaded >= scriptsRequested){
                g3Init();
            }
        }
    }
    //Misc
    function offset(el) {
        var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
    }
})();